import { Box, Tag, TagColor } from '@factorialco/deprecated-design-system'

export const Type: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Tag type={TagColor.grey}>{text}</Tag>
    </Box>
  )
}
